import { useSelector } from 'react-redux';

export function useNewStudents() {
  const { data: isNewStudent } = useSelector(
    (state: any) => state.getStudentType
  );

  const { data: studentPeriods } = useSelector(
    (state: any) => state.getPeriods
  );

  const { data: dataExternalSettings } = useSelector(
    (state: any) => state.externalSettings
  );

  const academic = useSelector((state: any) => state.profile?.data?.academic);

  const showRegistrationButton = () => {
    if (isNewStudent === undefined || isNewStudent === false) {
      return true;
    }

    if (studentPeriods?.length === 1) {
      if (
        dataExternalSettings?.enrollment_period_code === academic.periodDesc
      ) {
        return false;
      }
      return true;
    }
    return true;
  };

  const newStudent = showRegistrationButton();

  return newStudent;
}
